<template>
  <div>
    <!--  -->
    <el-form>
      <el-form-item :error="errorMessage" style="margin-bottom: 7px">
        <el-input
          type="textarea"
          :autosize="true"
          readonly
          v-model="userNames"
          :disabled="disabled"
          :placeholder="placeholder"
          @focus="showDialog()"
        ></el-input>
      </el-form-item>
    </el-form>
    <!--  -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogVisible"
      append-to-body
      @close="closeUserDialog"
      width="60%"
    >
      <template>
        <el-row>
          <el-form inline>
            <el-form-item label="姓名">
              <el-input v-model="realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchForm">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row gutter="10" v-loading="dialogLoading">
          <el-col span="6">
            <div>
              <el-tabs type="border-card">
                <el-tab-pane label="部门">
                  <el-tree
                    v-loading="treeLoading"
                    :data="departmentTreeList"
                    :props="defaultProps"
                    @node-click="handleDeptNodeClick"
                  ></el-tree>
                </el-tab-pane>
                <el-tab-pane label="班组">
                  <el-tree
                    v-loading="treeLoading"
                    :data="groupTreeList"
                    :props="defaultProps_"
                    @node-click="handleGroupNodeClick"
                  ></el-tree>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col span="7">
            <div class="pane">
              <div v-if="!single" class="pane-header">
                <el-checkbox
                  @change="changeAllLeft"
                  v-model="allLeft"
                  :disabled="dataForUserSelect.length === 0"
                ></el-checkbox>
                全选
              </div>
              <el-checkbox
                v-for="(item, index) in dataForUserSelect"
                :key="index"
                v-model="item.checked"
                :disabled="item.disabled"
                style="box-sizing: border-box; width: 100%; padding: 1rem"
                @change="forSelectHandler(item)"
                >{{ item.realName }}</el-checkbox
              >
            </div>
          </el-col>
          <el-col span="4">
            <div style="text-align: center; margin: 20px 0">
              <el-tag type="info" v-if="single"> 单选 </el-tag>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveLeftAction"
                :disabled="moveLeftDisabled"
                >左移</el-button
              >
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveRightAction"
                :disabled="moveRightDisabled"
                >右移</el-button
              >
            </div>
          </el-col>
          <el-col span="7">
            <div class="pane">
              <div v-if="!single" class="pane-header">
                <el-checkbox
                  @change="changeAllRight"
                  v-model="allRight"
                  :disabled="dataSelectedUsers.length === 0"
                ></el-checkbox>
                全选
              </div>
              <!--  -->
              <el-checkbox
                v-for="(item, index) in dataSelectedUsers"
                :key="index"
                v-model="item.checked"
                style="box-sizing: border-box; width: 100%; padding: 1rem"
                @change="selectHandler"
                >{{ item.realName }}</el-checkbox
              >
            </div>
          </el-col>
        </el-row>
        <div style="text-align: center; padding-top: 1rem">
          <el-button
            type="primary"
            @click.native="submit"
            style="margin-right: 1rem"
          >
            提交
          </el-button>
          <el-button @click.native="cancel">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  treeByProjectDeptId,
  getUserListByDepartmentId,
  getGroupList,
  getMenberUserList,
} from "@/api/crmedical/group/group";
export default {
  props: {
    single: {
      default: false, //是否为单选模式
    },
    projectId: {
      default: "",
    },
    placeholder: {
      default: "",
    },
    remainUserListInside: {
      default: [], //选择的人员列表
    },
    disabled: {
      default: false,
    },
    //v-model默认
    value: {
      default: "",
    },
    //下面3个属性部推荐使用
    required: {
      default: false,
    },
    message: {
      default: "请选择人员",
    },
    allUserList: {
      default: () => [],
    },
  },
  data() {
    return {
      allLeft: false,
      allRight: false,
      dialogVisible: false,
      dialogLoading: false,
      errorMessage: "",
      userNames: "",
      //搜索条件
      realName: "",
      phone: "",
      treeLoading: false,
      moveLeftDisabled: true,
      moveRightDisabled: true,

      tempSelectedItemElement: "",

      dataForUserSelect: [],

      dataSelectedUsers: [],

      departmentTreeList: [],
      groupTreeList: [],

      defaultProps: {
        children: "children",
        label: "title",
      },
      defaultProps_: {
        label: "name",
      },
    };
  },
  watch: {
    //查看回显
    remainUserListInside: {
      handler() {
        this.remainUserListInsideReshow();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async showDialog() {
      console.log(this.projectId);
      if (!this.projectId) {
        this.$message.warning("请先选择一个项目");
        return;
      }
      this.dialogLoading = true;
      this.dialogVisible = true;
      try {
        const resDept = await treeByProjectDeptId({
          projectId: this.projectId,
        });
        this.departmentTreeList = resDept.data;
        const resGroup = await getGroupList({ projectId: this.projectId });
        this.groupTreeList = resGroup.data;
        this.remainUserListInsideReshow();
      } catch (err) {
        console.log("error==>", err);
      }
      this.dialogLoading = false;
    },
    remainUserListInsideReshow() {
      let cloneVal = this.deepClone(this.remainUserListInside);
      //1.传入的list的item中没有realName,从外面传入的allUserList中筛选
      if (cloneVal && cloneVal.length > 0 && !cloneVal[0]["realName"]) {
        this.dataSelectedUsers = this.allUserList.filter((ele) =>
          cloneVal.find((item) => item.id == ele.id)
        );
        //1.1注意这里取的是 realNameAndPhone
        this.userNames = this.dataSelectedUsers
          .map((ele) => ele.realNameAndPhone)
          .toString();
      } else {
        //2.传入的list的item中有 realName，直接取值显示
        this.dataSelectedUsers = cloneVal;
        this.userNames = this.dataSelectedUsers
          .map((ele) => ele.realName)
          .toString();
      }
    },
    //左全选
    changeAllLeft(v) {
      this.dataForUserSelect.forEach((item) => (item.checked = v));
      this.moveRightDisabled = !v;
    },
    //右全选
    changeAllRight(v) {
      this.dataSelectedUsers.forEach((item) => (item.checked = v));
      this.moveLeftDisabled = !v;
    },
    //搜索
    searchForm() {
      this.clearButtons();
      getUserListByDepartmentId({
        projectId: this.projectId,
        realName: this.realName,
        phone: this.phone,
      }).then((res) => {
        res.data.forEach((ele) => {
          ele.realName = ele.realNameAndPhone;
          ele.checked = false;
        });
        this.dataForUserSelect = this.deepClone(res.data);
        this.initDataForSelect();
      });
    },
    selectHandler() {
      this.moveLeftDisabled = true;
      let allCheck = true;
      this.dataSelectedUsers.forEach((ele) => {
        ele.checked && (this.moveLeftDisabled = false);
        !ele.checked && (allCheck = false);
      });
      this.allRight = allCheck;
    },
    forSelectHandler(item) {
      this.moveRightDisabled = true;
      let allCheck = true;
      let choosenCount = 0;
      this.dataForUserSelect.forEach((ele) => {
        if (ele.checked) {
          this.moveRightDisabled = false;
          choosenCount++;
        } else {
          allCheck = false;
        }
      });
      console.log("choosenCount==>", choosenCount);
      this.allLeft = allCheck;
      //单选模式特有
      if (this.single == true) {
        this.dataForUserSelect.map((ele) => {
          ele.checked = ele.id == item.id;
        });
      }
    },
    clearButtons() {
      this.allRight = false;
      this.allLeft = false;
      this.moveRightDisabled = true;
      this.moveLeftDisabled = true;
    },
    moveRightAction() {
      let i = 0;
      for (; i < this.dataForUserSelect.length; i++) {
        let item = this.dataForUserSelect[i];
        if (item.checked) {
          item.checked = false;
          this.dataForUserSelect.splice(i, 1);
          this.dataSelectedUsers.push(item);
          i--;
        }
      }
      this.clearButtons();
      //单选模式处理
      if (this.dataSelectedUsers.length > 0 && this.single) {
        console.log("1==>", 1);
        this.moveRightDisabled = true;
        this.dataForUserSelect.map((ele) => (ele.disabled = true));
      }
    },
    moveLeftAction() {
      let i = 0;
      for (; i < this.dataSelectedUsers.length; i++) {
        let item = this.dataSelectedUsers[i];
        if (item.checked) {
          item.checked = false;
          this.dataSelectedUsers.splice(i, 1);
          this.dataForUserSelect.push(item);
          i--;
        }
      }
      this.clearButtons();
      //单选模式处理
      if (this.dataSelectedUsers.length == 0 && this.single) {
        this.dataForUserSelect.map((ele) => (ele.disabled = false));
      }
    },
    handleDeptNodeClick(data) {
      this.treeLoading = true;
      this.clearButtons();
      let deptId = data.id;
      getUserListByDepartmentId({ deptId}).then((res) => {
        console.log(res);
        res.data.forEach((ele) => {
          ele.realName = ele.realNameAndPhone;
          ele.checked = false;
        });
        this.dataForUserSelect = this.deepClone(res.data);
        console.log(this.dataForUserSelect);
        this.initDataForSelect();
        this.treeLoading = false;
      });
      console.log(data);
    },
    handleGroupNodeClick(data) {
      this.treeLoading = true;
      this.clearButtons();
      let groupId = data.id;
      //班组成员
      getMenberUserList({ groupId }).then((res) => {
        console.log(res);
        res.data.forEach((ele) => {
          ele.realName = ele.realNameAndPhone;
          ele.checked = false;
        });
        this.dataForUserSelect = res.data;
        this.initDataForSelect();
        this.treeLoading = false;
      });
    },
    initDataForSelect() {
      console.log("initDataForSelect");
      let arrListSelected = this.deepClone(this.dataSelectedUsers);
      let arrListForSelect = this.deepClone(this.dataForUserSelect);
      if (arrListSelected.length > 0) {
        arrListSelected.forEach((ele) => {
          arrListForSelect.forEach((element, index) => {
            if (element.id === ele.id) {
              arrListForSelect.splice(index, 1);
            }
          });
        });
      }
      this.dataForUserSelect = arrListForSelect;
    },
    cancel() {
      this.dataSelectedUsers = [];
      this.dataForUserSelect = [];
      this.dialogVisible = false;
    },
    submit() {
      this.userNames = this.dataSelectedUsers
        .map((ele) => ele.realName)
        .toString();
      this.dataSelectedUsers.forEach((item) => (item.checked = ""));
      this.$emit("update:remainUserListInside", this.dataSelectedUsers);
      this.$emit(
        "input",
        this.dataSelectedUsers.map((item) => item.id).toString()
      );
      if (this.required == true && this.dataSelectedUsers.length == 0) {
        this.errorMessage = this.message;
      }
      this.dataSelectedUsers = [];
      this.dataForUserSelect = [];
      this.clearButtons();
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pane {
  height: 400px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  text-align: left;
  overflow: scroll;
}
.pane-header {
  height: 39px;
  line-height: 39px;
  padding-left: 1rem;
  border-bottom: 1px solid #e4e7ed;
}
::v-deep .el-dialog {
  margin: 2vh auto 2vh !important;
}
::v-deep .el-tabs__content {
  height: 332px;
  overflow: scroll;
}
</style>>
